// client/src/components/marketer/project/modals/DoneModal.js
import React from 'react';
import '../../../../styles/marketer/modals/ContractModals.css';

export default function DoneModal({ open, onClose }) {
  if (!open) return null;

  return (
    <div className="done-modal mbm-overlay">
      <div className="done-modal__content mbm">
        <button onClick={onClose} aria-label="close" className="done-modal__close mbm-close">×</button>
        <div className="done-modal__logo">S<span className="done-modal__logo-ad">Ad</span></div>
        <div className="done-modal__title mbm-title">프로젝트 제작이 완료되었습니다.</div>
        <div className="done-modal__message">
          진행중인 프로젝트 보기 및, 인플루언서 선정하기에서 프로젝트를 확인해보세요.
        </div>
        <div className="done-modal__actions mbm-foot">
          <button type="button" onClick={onClose} className="mb-btn mb-btn-primary">확 인</button>
        </div>
      </div>
    </div>
  );
}